(function Module() {
	'use strict';
    const {log,mySynchModules} = require('../globals');
	var config = mySynchModules.config;
	mySynch.controller('EmmFieldReportsController', [
		'$scope',
		'$rootScope',
	    '$window',
		'ApiFactory',
		'AuditService',
		'F360Constant',
		'MySynchFactory',
		'$interval',
		'$filter',
        '$q',
     	'$http',
    	'$sce',
		'ViewAuthorizationFactory',
    	'$timeout',
		function EmmFieldReportsController($s,$rootScope,$window, api, audit, constant, MSF, $interval,$filter,$q,$http,$sce,viewAuth,$timeout) {
            var self = this;
            let eMMApiUrl = "https://mysynchpythonservices-functionstage.azurewebsites.net/api/EmmFieldTestReports?code=9Dan7TVvCqaMNDgn7cO4ZLJRnCZjlZ4_bHr3VDVaBk0LAzFubFknmA=="
            $s.loading = false;
            $s.reportLoading = false;
            $s.refreshCheckInProgress = false;
            $s.canViewPage = true;   // TODO: remove this after development is complete
            self.dataUpdatedDate = null;

            $s.environ = MSF.getEnvironmentName()
            $s.reportReqData = {HerdId: 0, SessionId: 0}

            //TODO: refactor this variable to get the array from codefile 
            $s.pageViewBetaReq = ["eMM"];

            $s.currentActiveHerd = MSF.getActiveHerd();
            $s.currentActiveFarm = MSF.getActiveFarm();
            $s.territoryManager  = MSF.getActiveFarmTerritoryManager(); 

            $s.checkPermissions = function checkPermissions(callback){
              if(!viewAuth.farmIsInBeta($s.pageViewBetaReq)){
                  MSF.loadPage('Login');
              }

              callback();
            }

            var deregOnHerdChange = undefined;
			$s.shotSessionList = []
			$s.currentSelectedSession = undefined;
            $s.startStopSpinner = function startStopSpinner(){
                $s.loading = !$s.loading;
            }
            
            $s.buildShotListNameCollection = function buildShotListNameCollection(){
           		_.forEach($s.rawSessionList, function (rawSessionListItem){
           			var sessionListItem = {sessionListDisplay: "", sessListId: 0}
           			_.set(sessionListItem, "sessListId", _.get(rawSessionListItem, "herdShotSessionId"))
           			var sessionListItemDisplay = ""
           			var rawSessionShotListName = _.get(rawSessionListItem, "shotListName")
           			var sessionStartString = _.get(rawSessionListItem, "sessionStart")
           			// TODO: create unique display name
           			sessionListItemDisplay = rawSessionShotListName
           			_.set(sessionListItem, "sessionListDisplay", sessionListItemDisplay)
           			$s.shotSessionList.push(sessionListItem)
           		})
            };

            $s.$on("$destroy", function() {
                log.info("dashboard destroy called");
            
                deregOnHerdChange();
            });

            $s.changeSelectedSession = function changeSelectedSession(){
                $s.loading = true;
           		$s.loadEmmReports()
            }

            $s.loadEmmReports = function loadEmmReports(){
                _.set($s.reportReqData, "HerdId",  $s.herdId)
				api.post(eMMApiUrl,{},JSON.stringify($s.reportReqData),function(err,result) {
                	$s.loading = false;
                	$s.emmfieldreporthtml = result
                	$("#emmFieldReport").empty()
                	$("#emmFieldReport").append($s.emmfieldreporthtml)
              	});
            }

            $s.loadReports = function loadReports(){
                $s.loading = true;
            	api.getHerdShotSessionListByHerdId($s.herdId, function(err, sessionListResult){
             		$s.rawSessionList = sessionListResult
                    _.set($s.reportReqData, "SessionId",  _.get($s.rawSessionList, "[0].herdShotSessionId"))
             		$s.buildShotListNameCollection()
					$s.loadEmmReports()
            	})
            };

//TODO: make these global or within an Azure .Functions variable, or even CodeFile data-driven function setEMMFieldReportApiUrl(){
            function setEMMFieldReportApiUrl(){
               switch($s.environ){
                   case "PROD":
                       eMMApiUrl = "https://mysynchpythonservices-functionprod.azurewebsites.net/api/emmfieldtestreports?code=xOeKTHwZtjG0_PZ4VD5rkaly4kWEIQzbi-2IAK6d16hyAzFu_x0Iqw%3D%3D";
                       break;
                    case "STAGE":
                        eMMApiUrl = "https://mysynchpythonservices-functionstage.azurewebsites.net/api/EmmFieldTestReports?code=9Dan7TVvCqaMNDgn7cO4ZLJRnCZjlZ4_bHr3VDVaBk0LAzFubFknmA==";
                        break;
                    case "TEST":
                        eMMApiUrl = "https://mysynchpythonservices-functiontest.azurewebsites.net/api/EmmFieldTestReports?code=t5NO7l8Orr6JJgUoHo19TXMQ1mkuf7W_xVxj6oES2GpeAzFuByKFhg==";
                        break;
                    case "DEV":
                        eMMApiUrl = "https://mysynchpythonservices-functiondev.azurewebsites.net/api/EmmFieldTestReports?code=ecQNPa2MP6l9ixUN_xQ8DS0-EGTZtzDq38AwjQrB3XC2AzFup-OCPQ==";
                        break;
                    default: 
                        eMMApiUrl = "https://mysynchpythonservices-functionstage.azurewebsites.net/api/EmmFieldTestReports?code=9Dan7TVvCqaMNDgn7cO4ZLJRnCZjlZ4_bHr3VDVaBk0LAzFubFknmA==";
                        break;
               }
           }

            MSF.ready(function onMsfReady() {
				$s.currentActiveHerd = MSF.getActiveHerd();
                $s.currentActiveFarm = MSF.getActiveFarm();
                $s.territoryManager  = MSF.getActiveFarmTerritoryManager();
                $s.herdId = _.get($s.currentActiveHerd,'herdId',_.get($s.currentActiveFarm,'herds[0].herdId'));
                var herdLatestCowEventDate = _.get($s.currentActiveHerd, 'latestCowEventDate');
                self.dataUpdatedDate = !_.isUndefined(herdLatestCowEventDate) ? moment(herdLatestCowEventDate).format(MSF.i18n.format.dateLong) : '';
                
                $s.checkPermissions(function(){
					if(_.isEqual(_.get($s.currentActiveFarm,'allowEMM'),true)) {
                    	setEMMFieldReportApiUrl();
                    	$s.loadReports();
                	}

					deregOnHerdChange =   $s.$on('herd:changed', function(){
					$s.loading = false;

                	$s.currentActiveHerd = MSF.getActiveHerd();
	                $s.currentActiveFarm = MSF.getActiveFarm();
	                $s.territoryManager  = MSF.getActiveFarmTerritoryManager();

	                $s.herdId = _.get($s.currentActiveHerd,'herdId',_.get($s.currentActiveFarm,'herds[0].herdId'));

                    var currentActiveHerdAdditionalHerdData = MSF.getAdditionalHerdDataItem($s.herdId);
                    var metaLastEventDateString = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
                    self.dataUpdatedDate = !_.isUndefined(metaLastEventDateString) ? moment(metaLastEventDateString).format(MSF.i18n.format.dateLong) : '';
                $s.checkPermissions(function(){
					if(_.isEqual(_.get($s.currentActiveFarm,'allowEMM'),true)) {
                    	setEMMFieldReportApiUrl();
                    	$s.loadReports();
                	}})
      			});
        	})
		})
    }]);
})();
